import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientQuickbook: string;

export interface QuickbookProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
}

class QuickbookProgressUpdate {
    quickbookProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientQuickbookk = (typeof isClientQuickbook === "undefined") ? false : isClientQuickbook;

        if(isClientQuickbookk == "true") {
            this.quickbookProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Quickbook::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `quickbook_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to QuickBooks Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to QuickBooks Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }

    }

    updateProgress(data: QuickbookProgressChannelData) {
        console.log(data);
        $("#quickbook_sync").show();
        $("#quickbook_sync_btn").hide();
        $("#last_update").hide();
        $("#quickbook_sync_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#quickbookProgressLabel").text(`${data.progress}%`);
        $(".currentStatusDesc_Category").text(`${data.message}`)
        var bat = $(".categ_qb_sync").length == 1
        if (!data.inProgress && data.success && bat){
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $(".doSyncBtn").hide();
            $(".qbSyncBtn").show();
            $(".qbSyncBtn").removeAttr('disabled')
            $(".previewSyncBtn").removeAttr('disabled')
            $('.success-img').removeClass("hide");
            $('.success-img').show();
            $(".currentStatusDesc_Category").text('Synchronization preview complete')
        }
        if (!data.inProgress && data.success && !bat) {
            this.refresh();
            $("#quickbook_sync_btn").show();
            $("#last_update").show();
        }
        if (!data.success) {
            this.refresh();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const quickbook = new QuickbookProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new QuickbookProgressUpdate();
    });
}
